import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      api.get('/auth/me')
        .then(({ data }) => {
          const u = data.data;
          // Normalize — ensure both role and role_slug are set
          setUser({ ...u, role: u.role || u.role_slug, role_slug: u.role_slug || u.role });
        })
        .catch(() => localStorage.clear())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password, extra = {}) => {
    const { data } = await api.post('/auth/login', { email, password, ...extra });
    localStorage.setItem('access_token', data.data.access_token);
    localStorage.setItem('refresh_token', data.data.refresh_token);
    const u = data.data.user;
    const normalized = { ...u, role: u.role || u.role_slug, role_slug: u.role_slug || u.role };
    setUser(normalized);
    return normalized;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.clear();
    setUser(null);
  };

  // Permission helper: can(module, action)
  const can = (module, action = 'can_read') => {
    if (!user) return false;
    if ((user.role_slug || user.role) === 'super_admin') return true;
    const perm = user.permissions?.find(p => p.module === module);
    return perm?.[action] === true;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
